"use client";
import { useAtom } from "jotai";
import { ReactNode, useCallback } from "react";
import { StyledPopover } from "../components/core/Popover";
import { PopoverAtom } from "../store/popoverAtom";

export interface PopoverOptions {
  hidePopoverFrame?: boolean;
  cancelPressOutside?: boolean;
}
export const usePopover = () => {
  const [popover, setPopover] = useAtom(PopoverAtom);

  const showPopover = useCallback(
    (jsx: ReactNode, popoverOptions?: PopoverOptions) => {
      if (popoverOptions?.hidePopoverFrame) {
        setPopover(<>{jsx}</>);
      }

      setPopover(<StyledPopover options={popoverOptions}>{jsx}</StyledPopover>);
    },
    [setPopover]
  );
  const hidePopover = useCallback(() => {
    setPopover(null);
  }, [setPopover]);

  return { popover, showPopover, hidePopover };
};
